import {Injectable} from '@angular/core';
import {KetoParams} from './ketoParams';
import {Observable, of} from 'rxjs';
import {KetoResult} from './ketoResult';
import * as keto from '../lib/keto.js';
import {KetoAlgParams} from './ketoAlgParams';

@Injectable({
  providedIn: 'root'
})
export class ResultCalculationsService {

  getLogic(params: KetoParams): KetoResult {

    const paramsAlg = new KetoAlgParams();
    paramsAlg.gender = (params.gender === 'female' ? 0 : 1);
    paramsAlg.activityLevel = params.activity;
    paramsAlg.age = params.age;
    paramsAlg.netCarbs = params.carbs;
    paramsAlg.bodyfat = params.fat;
    paramsAlg.height = params.height;
    paramsAlg.weight = params.weight;
    paramsAlg.adjustment = params.adjustment;

    console.log(paramsAlg);

    const kdb = new keto.KetoDietBuddy(paramsAlg);
    console.log(kdb);

    const kdbResult = kdb.calculateCalorieIntake(paramsAlg.adjustment);

    const result = new KetoResult();
    result.maintenance.energy = kdbResult.maintenance.energy;
    result.maintenance.gramsFat = kdbResult.maintenance.gramsFat;
    result.maintenance.gramsProtein = kdbResult.maintenance.gramsProtein;
    result.maintenance.gramsNetCarbs = kdbResult.maintenance.gramsNetCarbs;
    result.maintenance.energyFat = kdbResult.maintenance.energyFat;
    result.maintenance.energyProtein = kdbResult.maintenance.energyProtein;
    result.maintenance.energyNetCarbs = kdbResult.maintenance.energyNetCarbs;
    result.maintenance.percEnergyNetCarbs = kdbResult.maintenance.percEnergyNetCarbs;
    result.maintenance.percEnergyProtein = kdbResult.maintenance.percEnergyProtein;
    result.maintenance.percEnergyFat = kdbResult.maintenance.percEnergyFat;
    result.minimum.energy = kdbResult.minimum.energy;
    result.minimum.gramsFat = kdbResult.minimum.gramsFat;
    result.minimum.gramsProtein = kdbResult.minimum.gramsProtein;
    result.minimum.gramsNetCarbs = kdbResult.minimum.gramsNetCarbs;
    result.minimum.energyFat = kdbResult.minimum.energyFat;
    result.minimum.energyProtein = kdbResult.minimum.energyProtein;
    result.minimum.energyNetCarbs = kdbResult.minimum.energyNetCarbs;
    result.minimum.percEnergyNetCarbs = kdbResult.minimum.percEnergyNetCarbs;
    result.minimum.percEnergyProtein = kdbResult.minimum.percEnergyProtein;
    result.minimum.percEnergyFat = kdbResult.minimum.percEnergyFat;
    result.desirable.energy = kdbResult.desirable.energy;
    result.desirable.gramsFat = kdbResult.desirable.gramsFat;
    result.desirable.gramsProtein = kdbResult.desirable.gramsProtein;
    result.desirable.gramsNetCarbs = kdbResult.desirable.gramsNetCarbs;
    result.desirable.energyFat = kdbResult.desirable.energyFat;
    result.desirable.energyProtein = kdbResult.desirable.energyProtein;
    result.desirable.energyNetCarbs = kdbResult.desirable.energyNetCarbs;
    result.desirable.percEnergyNetCarbs = kdbResult.desirable.percEnergyNetCarbs;
    result.desirable.percEnergyProtein = kdbResult.desirable.percEnergyProtein;
    result.desirable.percEnergyFat = kdbResult.desirable.percEnergyFat;
    result.bmr = kdb.bmr;

    return result;
  }

}
